import { Outlet } from 'react-router-dom'
import { TooltipProvider } from '@/components/ui/tooltip'
import { MatrixRain } from '@/components/matrix-rain'
import { RateLimitBanner } from '@/components/rate-limit-banner'
import { ImpersonationBanner } from '@/components/impersonation-banner'
import { HelpProvider } from '@/components/help/help-provider'
import { WalkthroughHost } from '@/components/help/walkthrough'
import { Sidebar } from './sidebar'
import { TopBar } from './top-bar'
import { BottomNav } from './bottom-nav'
import { MobileSidebar } from './mobile-sidebar'

export function AppLayout() {
  return (
    <TooltipProvider delayDuration={0}>
      <HelpProvider>
        <div className="relative h-screen overflow-hidden">
          {/* Ambient matrix-rain background — mirrors dealcloserautopilot.com. */}
          <MatrixRain />

          {/* Foreground app layout, lifted above the background canvas */}
          <div className="relative z-10 flex h-full">
            <Sidebar />
            <MobileSidebar />

            <div className="flex min-w-0 flex-1 flex-col overflow-hidden">
              <TopBar />
              {/* Staff "view as user" banner — only renders while impersonating. */}
              <ImpersonationBanner />
              {/* Rate-limit warning banner sits between the top bar and main
                  content. Self-hides when every tracked endpoint is below 80%
                  of its daily cap, so most customers most days never see it. */}
              <RateLimitBanner />

              <main className="flex-1 overflow-y-auto pb-16 md:pb-0">
                <Outlet />
              </main>
            </div>

            <BottomNav />
          </div>
        </div>

        {/* First-run walkthrough overlay; renders only while a tour is active. */}
        <WalkthroughHost />
      </HelpProvider>
    </TooltipProvider>
  )
}
